<script setup lang="ts">
import { computed } from 'vue'
import { useRouter }  from '#imports'
import { useI18n } from 'vue-i18n'
import { faUpRightFromSquare } from '@fortawesome/duotone-regular-svg-icons'
import { useMessagesStore } from '~/stores/messages'
import usePaywallOverlay from '~/composables/usePaywallOverlay'
import RichTextRenderer from '~/components/utils/RichTextRenderer.vue'
import LoginButtons from '~/components/login/LoginButtons.vue'
import AuLogoSimple from "~/components/utils/AuLogoSimple.vue";
import Button from "~/components/ui/Button.vue";
import AuCallout from "~/components/ui/AuCallout.vue";

const router = useRouter()
const { t } = useI18n()
const { hasLoginMessage, messages } = useMessagesStore()
const { washPage } = usePaywallOverlay()

const webshopUrl = <string>import.meta.env.VITE_WEBSHOP_SITEURL
const currentPath = computed(() => router.currentRoute.value.fullPath)
</script>

<template>
  <Transition
    tag="div"
    class="paywall-overlay-ignore z-20"
    enter-active-class="duration-500 delay-500"
    enter-from-class="translate-y-full opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    appear
    paywall-overlay-ignore
    @after-enter="washPage"
  >
    <div class="absolute h-screen w-screen bg-gradient-to-b from-transparent via-green-50 to-black">
      <div class="container mx-auto h-screen">
        <div class="absolute inset-x-0 z-20 m-auto h-fit shadow-2xl top-2/3 -translate-y-2/3 max-w-prose rounded-xl bg-green-40 border-green-20 text-green-5 p-10 text-center sm:border">
          <div class="mb-3 inline-flex rounded-full p-2 text-seagreen-50">
            <AuLogoSimple class="mx-auto h-16 w-auto pt-8 text-green-5" />
          </div>
          <p
            class="mb-5 mt-3"
            v-text="t('login.intro')"
          />
          <AuCallout
            v-if="hasLoginMessage"
            :title="messages?.loginMessageTitle"
            variant="warning"
            class="mb-8"
          >
            <RichTextRenderer :text="messages?.loginMessage ?? ''" />
          </AuCallout>
          <div class="grid w-full gap-4 px-10 justify-center">
            <LoginButtons :redirect-to="currentPath" />
          </div>
          <div class="grid-cols-l grid w-full place-items-center gap-4 px-10 py-4 sm:py-6">
            <Button
              variant="ghost"
              :href="webshopUrl"
              shade="light"
              target="_blank"
            >
              {{ t('login.more') }}
              <font-awesome-icon :icon="faUpRightFromSquare" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>
